import { Search, SlidersHorizontal } from "lucide-react";
import "../styles/Search.css";

export default function FoodSearch({ setIsFilterOpen, search, setSearch, activeFilterCount }) {
  return (
    <div className="af-search-row">
      {/* Search input */}
      <div className="af-search-input-wrap">
        <Search size={16} color="#9ca3af" className="af-search-icon" />
        <input
          type="text"
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="Search for food…"
          className="af-search-input"
        />
      </div>

      {/* Filter button — mobile only */}
      <button
        className={`af-filter-btn ${activeFilterCount > 0 ? "active" : ""}`}
        onClick={() => setIsFilterOpen(prev => !prev)}
        aria-label="Open filters"
      >
        <SlidersHorizontal size={15} />
        <span className="af-filter-btn-label">Filters</span>
        {activeFilterCount > 0 && (
          <span className="af-filter-count">{activeFilterCount}</span>
        )}
      </button>
    </div>
  );
}
